
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Le début de la troisième vague`}</h2>
    <p>{`Pour la troisième vague, sont pris en compte les cas confirmés du 25 février au 13 avril 2021. L’analyse géographique montre que certaines parties de Suisse romande présentent à nouveau un nombre d’infections par habitant plus élevé. C'est cependant dans le canton d'Uri qu'un nouveau cluster important apparaît.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;